import { tv } from 'tailwind-variants';
import { Icon, withConfirmation } from '@frontendmentorio/design-system-v2';

const ConfirmButton = withConfirmation(({ ...props }) => <button {...props} />);

const styles = tv({
  base: ['bg-rose-600', 'h-[2rem]', 'rounded-full', 'w-[2rem]'],
});

export default function AdminDeleteButton({
  className,
  onClick: handleClick,
  modal,
}) {
  return (
    <ConfirmButton
      className={styles({ class: className })}
      modal={modal}
      onClick={handleClick}
    >
      <Icon className="text-white text-sm" name="trash" style="solid" />
    </ConfirmButton>
  );
}
